exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid {\n  height: 100%; }\n\n.timeline {\n  width: 100%;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  background: white !important; }\n\n.timeline .vis-timeline {\n    background: white !important; }\n\n.vis-item {\n  background-color: #2185D0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/announcements/announcements.component.scss
// module id = ../../../../../src/app/announcements/announcements.component.scss
// module chunks = main